import { Routes, Route, Navigate } from "react-router-dom";
import LoanApplicationView from "../pages/StaffPortal/LoanApplicationView";
import MainLayout from "./MainLayout";
import StaffDashboard from "../pages/StaffPortal/NewStaffDashboard";
import Attendance from "../pages/StaffPortal/Attendance";
import Customer from "../pages/StaffPortal/Customer";
import { Toaster } from "react-hot-toast";
import UniversalAnalysers from "../pages/AdminPortal/UniversalAnalysers";
import AddStaff from "../pages/AdminPortal/Addstaff";
import AffiliatedNew from "../pages/AdminPortal/AffiliatedNew";

const StaffLayout = () => {
  return (
    <MainLayout>
      <Routes>
        <Route path="dashboard" element={<StaffDashboard />} />
        <Route path="customers" element={<Customer />} />
        <Route path="loan-applications/:id" element={<LoanApplicationView />} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="universal-analysers/:id" element={<UniversalAnalysers />} />
        <Route path="add-staff" element={<AddStaff />} />
        <Route path="add-affiliate-partner" element={<AffiliatedNew />} />

        <Route
          path="*"
          element={
            <div className="flex items-center justify-center min-h-screen bg-[#131313] text-white p-4">
              <div className="text-center">
                <h1 className="text-5xl font-bold text-[#FFCA20] mb-4">404</h1>
                <h2 className="text-2xl mb-4">Page Not Found</h2>
                <p className="text-gray-400 mb-6">
                  The page you are looking for doesn't exist or you are not
                  authorised.
                </p>
                <a
                  href="/staff/dashboard"
                  className="bg-[#FFCA20] hover:bg-yellow-600 text-black font-medium py-2 px-6 rounded"
                >
                  Go to Dashboard
                </a>
              </div>
            </div>
          }
        />
      </Routes>
      <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
    </MainLayout>
  );
};

export default StaffLayout;
